module.exports = __webpack_public_path__ + "static/image2-2108b2d8fcc49eb893f22d415894bc32.jpg";